module.exports = __webpack_public_path__ + "static/media/Tempate11on1.7ac750d1.png";